<template>
  <div class="menu-item-inner">
    <i v-if="icon" :class="icon" class="menu-icon" />
    <span v-if="title" slot="title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.menu-item-inner {
  display: flex;
  align-items: center;
  gap: 8px;
}
.menu-icon {
  font-size: 16px;
  flex-shrink: 0;
}
</style>
